import AGREGAR_OBRA from '@/graphql/mutations/administracion/planeacion/agregarObra.gql';
import OBRAS from '@/graphql/querys/administracion/planeacion/obras.gql';
import ACTUALIZAR_OBRA from '@/graphql/mutations/administracion/planeacion/actualizarObra.gql';
import REMOVER_OBRA from '@/graphql/mutations/administracion/planeacion/removerObra.gql';
import TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/tiposobras/tiposObras.gql';
import SUB_TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/subtiposobras/subTiposObras.gql';
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import PROGRAMAS_INVERSIONES from '@/graphql/querys/administracion/catalogos/programasinversiones/programasInversiones.gql';

export default {
  apollo: {
    tiposObras: {
      query: TIPOS_OBRAS,
    },
    subTiposObras: {
      query: SUB_TIPOS_OBRAS,
    },
    municipios: {
      query: MUNICIPIOS,
    },
    programasInversiones: {
      query: PROGRAMAS_INVERSIONES,
    },
  },
  methods: {
    mixGuardarBasico() {
      return this.$apollo.mutate({
        mutation: AGREGAR_OBRA,
        variables: {
          obra: this.obra,
        },
      })
        .then((resultado) => resultado)
        .catch((err) => ({ err }));
    },
    async mixAgregarObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_OBRA,
        variables: {
          obra: this.obra,
        },
        update: (store, { data: { agregarObra } }) => {
          const data = store.readQuery({ query: OBRAS });
          data.obras.push(agregarObra);
          store.writeQuery({ query: OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_OBRA,
        variables: {
          id: this.obraEditar.id,
          obra: this.obra,
        },
        update: (store, { data: { actualizarObra } }) => {
          const data = store.readQuery({ query: OBRAS });
          const { obras } = data;
          const index = obras
            .findIndex((obra) => obra.id === actualizarObra.id);
          if (index !== -1) {
            obras.splice(index, 1, actualizarObra);
          }
          store.writeQuery({ query: OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
        // console.log(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_OBRA,
        variables: {
          id: this.obraEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: OBRAS });
          const { obras } = data;
          const index = obras
            .findIndex((obra) => obra.id === this.obraEliminar.id);
          if (index !== -1) {
            obras.splice(index, 1);
          }
          store.writeQuery({ query: OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    getSubTipoObraPorTipo() {
      if (!this.subTiposObras || this.obra.idTipo === '') return [];
      return this.subTiposObras
        .filter(({ idTipo }) => idTipo === this.obra.idTipo);
    },
  },
};
